export default __webpack_public_path__ + "static/media/IMG_0432-2.656eb797.jpg";